// Saves a change to a site's draft (the next version, approved on the ops tablet).
import type { SiteDraft } from '../../../../src/draft.ts';
import { api } from '../../api.ts';
import type { SiteView } from '../../types.ts';

export async function saveDraft(site: SiteView, patch: Partial<SiteDraft>): Promise<void> {
  await api('PUT', `/sites/${site.siteId}/draft`, {
    clientName: site.clientName,
    siteName: site.siteName,
    timeZone: site.timeZone,
    draft: { ...(site.draft as SiteDraft), ...patch },
  });
}
